import * as React from 'react';
import PropTypes from 'prop-types';

const SvgSportsSkiNormalMedium = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M19.77 16.66l4.9-9.22A6.371 6.371 0 0024.4 1h-1.94l-5.51 10.36.93 1.76.69-1.29h1.89l-1.63 3.07zm-.32-6.49l3.98-7.48a4.688 4.688 0 01-.22 3.97l-1.87 3.51zm-7.22 10.05L6.06 31.83h5.64l3.35-6.31-.72-1.35H12l1.17-2.19zm.79 5.61l-2.31 4.34h-1.9l2.31-4.34zm12.92 6l-6.19-11.64L9.54 1H7.6a6.372 6.372 0 00-.27 6.44L20.3 31.83zM8.79 6.66a4.688 4.688 0 01-.22-3.97l3.98 7.48h-1.89zM16 20.22l-4.46-8.39h1.89L20 24.17h-1.9zm4.88 5.61l2.31 4.34h-1.9l-2.31-4.34z"
        fill=""
      />
    </svg>
  )
);
SvgSportsSkiNormalMedium.defaultProps = {
  color: 'currentColor',
  size: 32,
  title: undefined,
  titleId: undefined
};
SvgSportsSkiNormalMedium.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgSportsSkiNormalMedium;
